module.exports = __webpack_public_path__ + "static/img/b5.c4b17245.png";